export default __webpack_public_path__ + "images/8eaaafe51cca05799ef04868d315abe4.png";